/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import * as types from '../types'
const alert = (state = {}, action) => {
  switch (action.type) {
    case types.alert.SUCCESS:
      return {...state,
        type: 'success',
        message: action.message,
      }
    case types.alert.ERROR:
      return {
        ...state,
        type: 'error',
        message: action.message,
      }
    case types.alert.CLEAR:
      return {}
    default:
      return state
  }
}

export default alert
